import healthIndex from '@/views/health/healthIndex.vue';
import registerIndex from '@/views/health/register/index.vue';
import payIndex from '@/views/health/pay/index.vue';
import medicineIndex from '@/views/health/medicine/index.vue';
import consultationIndex from '@/views/health/consultation/index.vue';
import queryIndex from '@/views/health/query/index.vue';
import activationIndex from '@/views/health/activation/index.vue';
import insuranceIndex from '@/views/health/insurance/index.vue';
import applyIndex from '@/views/health/apply/index.vue';

export default {
  path: '/health',
  component: {
    render(c) { return c('router-view'); }
  },
  children: [
    // 医疗健康首页
    {
      path: 'healthIndex',
      name: 'healthIndex',
      component: healthIndex
    },
     // 预约挂号首页
    {
      path: 'register/index',
      name: 'registerIndex',
      component: registerIndex
    },
    // 医保支付首页
    {
      path: 'pay/index',
      name: 'payIndex',
      component: payIndex
    },
     // 手机买药首页
    {
      path: 'medicine/index',
      name: 'medicineIndex',
      component: medicineIndex
    },
     // 在线问诊首页
    {
      path: 'consultation/index',
      name: 'consultationIndex',
      component: consultationIndex
    },
     // 医保账户查询首页
    {
      path: 'query/index',
      name: 'queryIndex',
      component: queryIndex
    },
     // 医保电子凭证激活首页
    {
      path: 'activation/index',
      name: 'activationIndex',
      component: activationIndex
    },
     // 城乡居民医疗保险缴费首页
    {
      path: 'insurance/index',
      name: 'insuranceIndex',
      component: insuranceIndex
    },
     // 门诊慢特病病种申请首页
    {
      path: 'apply/index',
      name: 'applyIndex',
      component: applyIndex
    },
  ]
};
